import React from "react";
import { twMerge } from "tailwind-merge";
import { theme } from "./index";

interface JobsProps {
  className?: string;
}

export const Jobs: React.FC<JobsProps> = ({ className }) => (
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge(
      theme,
      className,
    )}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.80179 0.764282C4.7337 0.764282 3.86786 1.63013 3.86786 2.69821V10.4339C3.86786 11.502 4.7337 12.3679 5.80179 12.3679H16.1161C17.1841 12.3679 18.05 11.502 18.05 10.4339V2.69821C18.05 1.63013 17.1841 0.764282 16.1161 0.764282H5.80179ZM1.93393 6.88839C1.93393 6.35435 1.501 5.92143 0.966964 5.92143C0.432924 5.92143 0 6.35435 0 6.88839V13.9795C0 15.2256 1.01016 16.2357 2.25625 16.2357H11.9259C12.4599 16.2357 12.8929 15.8028 12.8929 15.2687C12.8929 14.7347 12.4599 14.3018 11.9259 14.3018H2.25625C2.07824 14.3018 1.93393 14.1575 1.93393 13.9795V6.88839Z"
    />
  </svg>
);
